import { render, staticRenderFns } from "./pro.vue?vue&type=template&id=ba8270c8&"
import script from "./pro.vue?vue&type=script&lang=js&"
export * from "./pro.vue?vue&type=script&lang=js&"
import style0 from "./pro.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pro.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pro.vue"
export default component.exports